module.exports = __webpack_public_path__ + "static/1-a2d0dcddcbaa937482c6df3085e07f63.png";